module.exports = __webpack_public_path__ + "img/Surfing10_Classic.ce0857ca.png";